

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class VenueEvent_ManagedObject

class VenueEvent_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: beginDateTime
    set beginDateTime(value:Date) {
        this.setValueForKey(value, 'beginDateTime');
    }
    get beginDateTime():Date {
        return this.valueForKey('beginDateTime');
    }
    set beginDateTimePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'beginDateTime');
    }
    get beginDateTimePrimitiveValue():Date {
        return this.primitiveValueForKey('beginDateTime');
    }

    // Property: endDateTime
    set endDateTime(value:Date) {
        this.setValueForKey(value, 'endDateTime');
    }
    get endDateTime():Date {
        return this.valueForKey('endDateTime');
    }
    set endDateTimePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'endDateTime');
    }
    get endDateTimePrimitiveValue():Date {
        return this.primitiveValueForKey('endDateTime');
    }

    // Property: externalReference
    set externalReference(value:string) {
        this.setValueForKey(value, 'externalReference');
    }
    get externalReference():string {
        return this.valueForKey('externalReference');
    }
    set externalReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'externalReference');
    }
    get externalReferencePrimitiveValue():string {
        return this.primitiveValueForKey('externalReference');
    }

    // Property: isActive
    set isActive(value:boolean) {
        this.setValueForKey(value, 'isActive');
    }
    get isActive():boolean {
        return this.valueForKey('isActive');
    }
    set isActivePrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'isActive');
    }
    get isActivePrimitiveValue():boolean {
        return this.primitiveValueForKey('isActive');
    }

    // Property: kind
    set kind(value:number) {
        this.setValueForKey(value, 'kind');
    }
    get kind():number {
        return this.valueForKey('kind');
    }
    set kindPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'kind');
    }
    get kindPrimitiveValue():number {
        return this.primitiveValueForKey('kind');
    }

    // Property: maxPax
    set maxPax(value:number) {
        this.setValueForKey(value, 'maxPax');
    }
    get maxPax():number {
        return this.valueForKey('maxPax');
    }
    set maxPaxPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'maxPax');
    }
    get maxPaxPrimitiveValue():number {
        return this.primitiveValueForKey('maxPax');
    }

    // Property: minPax
    set minPax(value:number) {
        this.setValueForKey(value, 'minPax');
    }
    get minPax():number {
        return this.valueForKey('minPax');
    }
    set minPaxPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'minPax');
    }
    get minPaxPrimitiveValue():number {
        return this.primitiveValueForKey('minPax');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: pax
    set pax(value:number) {
        this.setValueForKey(value, 'pax');
    }
    get pax():number {
        return this.valueForKey('pax');
    }
    set paxPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'pax');
    }
    get paxPrimitiveValue():number {
        return this.primitiveValueForKey('pax');
    }

    // Property: presetGroupID
    set presetGroupID(value:string) {
        this.setValueForKey(value, 'presetGroupID');
    }
    get presetGroupID():string {
        return this.valueForKey('presetGroupID');
    }
    set presetGroupIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'presetGroupID');
    }
    get presetGroupIDPrimitiveValue():string {
        return this.primitiveValueForKey('presetGroupID');
    }

    // Property: price
    set price(value:number) {
        this.setValueForKey(value, 'price');
    }
    get price():number {
        return this.valueForKey('price');
    }
    set pricePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'price');
    }
    get pricePrimitiveValue():number {
        return this.primitiveValueForKey('price');
    }

    // Property: rateID
    set rateID(value:string) {
        this.setValueForKey(value, 'rateID');
    }
    get rateID():string {
        return this.valueForKey('rateID');
    }
    set rateIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'rateID');
    }
    get rateIDPrimitiveValue():string {
        return this.primitiveValueForKey('rateID');
    }

    // Property: ratesInfo
    set ratesInfo(value:string) {
        this.setValueForKey(value, 'ratesInfo');
    }
    get ratesInfo():string {
        return this.valueForKey('ratesInfo');
    }
    set ratesInfoPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'ratesInfo');
    }
    get ratesInfoPrimitiveValue():string {
        return this.primitiveValueForKey('ratesInfo');
    }

    // Property: registrationInfo
    set registrationInfo(value:string) {
        this.setValueForKey(value, 'registrationInfo');
    }
    get registrationInfo():string {
        return this.valueForKey('registrationInfo');
    }
    set registrationInfoPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'registrationInfo');
    }
    get registrationInfoPrimitiveValue():string {
        return this.primitiveValueForKey('registrationInfo');
    }

    // Property: status
    set status(value:number) {
        this.setValueForKey(value, 'status');
    }
    get status():number {
        return this.valueForKey('status');
    }
    set statusPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'status');
    }
    get statusPrimitiveValue():number {
        return this.primitiveValueForKey('status');
    }

    // Property: totalAmount
    set totalAmount(value:number) {
        this.setValueForKey(value, 'totalAmount');
    }
    get totalAmount():number {
        return this.valueForKey('totalAmount');
    }
    set totalAmountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'totalAmount');
    }
    get totalAmountPrimitiveValue():number {
        return this.primitiveValueForKey('totalAmount');
    }

    // Relationship: bookings
    protected _bookings:MIOManagedObjectSet = null;
    get bookings():MIOManagedObjectSet {
        return this.valueForKey('bookings');
    }
    addBookingsObject(value:Booking) {
        this._addObjectForKey(value, 'bookings');
    }
    removeBookingsObject(value:Booking) {
        this._removeObjectForKey(value, 'bookings');
    }
    // Relationship: eventInvitationRule
    set eventInvitationRule(value:EventInvitationRule) {
        this.setValueForKey(value, 'eventInvitationRule');
    }
    get eventInvitationRule():EventInvitationRule {
        return this.valueForKey('eventInvitationRule') as EventInvitationRule;
    }
    // Relationship: eventProgram
    set eventProgram(value:EventProgram) {
        this.setValueForKey(value, 'eventProgram');
    }
    get eventProgram():EventProgram {
        return this.valueForKey('eventProgram') as EventProgram;
    }
    // Relationship: eventType
    set eventType(value:VenueEventType) {
        this.setValueForKey(value, 'eventType');
    }
    get eventType():VenueEventType {
        return this.valueForKey('eventType') as VenueEventType;
    }

    // Relationship: guests
    protected _guests:MIOManagedObjectSet = null;
    get guests():MIOManagedObjectSet {
        return this.valueForKey('guests');
    }
    addGuestsObject(value:BookingGuest) {
        this._addObjectForKey(value, 'guests');
    }
    removeGuestsObject(value:BookingGuest) {
        this._removeObjectForKey(value, 'guests');
    }
    // Relationship: image
    set image(value:DBImage) {
        this.setValueForKey(value, 'image');
    }
    get image():DBImage {
        return this.valueForKey('image') as DBImage;
    }

    // Relationship: invitationLines
    protected _invitationLines:MIOManagedObjectSet = null;
    get invitationLines():MIOManagedObjectSet {
        return this.valueForKey('invitationLines');
    }
    addInvitationLinesObject(value:InvitationLine) {
        this._addObjectForKey(value, 'invitationLines');
    }
    removeInvitationLinesObject(value:InvitationLine) {
        this._removeObjectForKey(value, 'invitationLines');
    }

    // Relationship: items
    protected _items:MIOManagedObjectSet = null;
    get items():MIOManagedObjectSet {
        return this.valueForKey('items');
    }
    addItemsObject(value:EventItem) {
        this._addObjectForKey(value, 'items');
    }
    removeItemsObject(value:EventItem) {
        this._removeObjectForKey(value, 'items');
    }
    // Relationship: offer
    set offer(value:Offer) {
        this.setValueForKey(value, 'offer');
    }
    get offer():Offer {
        return this.valueForKey('offer') as Offer;
    }

    // Relationship: tickets
    protected _tickets:MIOManagedObjectSet = null;
    get tickets():MIOManagedObjectSet {
        return this.valueForKey('tickets');
    }
    addTicketsObject(value:EventTicket) {
        this._addObjectForKey(value, 'tickets');
    }
    removeTicketsObject(value:EventTicket) {
        this._removeObjectForKey(value, 'tickets');
    }

    // Relationship: timeRangePresetConfigurations
    protected _timeRangePresetConfigurations:MIOManagedObjectSet = null;
    get timeRangePresetConfigurations():MIOManagedObjectSet {
        return this.valueForKey('timeRangePresetConfigurations');
    }
    addTimeRangePresetConfigurationsObject(value:TimeRangePresetConfiguration) {
        this._addObjectForKey(value, 'timeRangePresetConfigurations');
    }
    removeTimeRangePresetConfigurationsObject(value:TimeRangePresetConfiguration) {
        this._removeObjectForKey(value, 'timeRangePresetConfigurations');
    }
}
